function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const HelpScoutIcon = _ref => {
  let {
    size,
    bg,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 231 231",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#1390EC",
    d: "M0 0h231v231H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    fill: "#FFF",
    d: "m103.82 77.75-53.38 54.52c-6.67-6.82-10.84-16.19-11.68-27.26 0-10.22 5-20.45 11.68-27.26l54.21-54.52c6.67 6.82 10.84 17.04 10.84 27.26.01 10.23-4.99 20.45-11.67 27.26zm23.48 75.5 53.96-54.52c6.75 7.67 10.96 17.04 10.96 27.26 0 10.22-5.06 20.45-11.8 27.26l-53.96 54.52c-6.75-6.82-10.96-17.04-10.96-27.26s5.06-20.45 11.8-27.26zm-1.32-75.5 15.93-15.94 39.41-38.58c6.71 6.71 10.9 16.78 10.9 26.84s-5.03 20.13-11.74 26.84l-38.57 38.58-15.93 15.94-22.64 22.65-15.93 15.94-37.73 37.75c-6.71-6.71-10.9-16.78-10.9-26.84s5.03-20.13 11.74-26.84l37.73-37.75 15.09-15.94 22.64-22.65z"
  }));
};
HelpScoutIcon.defaultProps = {
  size: 16,
  bg: '#1F8DED'
};
export default HelpScoutIcon;